import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hot/image/search-icon.png'
import _imports_1 from '@/assets/star/emptyBlack.png'
import _imports_2 from '@/assets/star/emptyWhite.png'


const _withScopeId = n => (_pushScopeId("data-v-e22f68bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "搜索",
  style: {"width":"20px","height":"20px"}
}, null, -1))
const _hoisted_2 = {
  key: 0,
  src: _imports_1,
  alt: "",
  style: {"width":"38%","height":"38%"}
}
const _hoisted_3 = {
  key: 1,
  src: _imports_2,
  alt: "",
  style: {"width":"38%","height":"38%"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "margin-top: 35px" }, "未找到相关股票", -1))
const _hoisted_5 = {
  key: 1,
  class: "searchlist"
}
const _hoisted_6 = {
  key: 0,
  class: "history"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "历史搜索", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["searchStockSelectwrap", _ctx.theme]),
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handlefocusInput && _ctx.handlefocusInput(...args)))
  }, [
    _createVNode(_component_a_input, {
      ref: "askingselect",
      placeholder: _ctx.placeholder,
      autocomplete: "off",
      id: "askingInput",
      allowClear: true,
      value: _ctx.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      onFocus: _ctx.focusSelect,
      onBlur: _ctx.blurSelect,
      onKeyup: _ctx.inputKeyup,
      onChange: _ctx.handleInputChange,
      onCompositionstart: _ctx.handleCompositionStart,
      onCompositionend: _ctx.handleCompositionEnd
    }, {
      prefix: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["placeholder", "value", "onFocus", "onBlur", "onKeyup", "onChange", "onCompositionstart", "onCompositionend"]),
    (_ctx.showDropdown && _ctx.searchstr && !_ctx.options.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([_ctx.theme === 'dark' ? 'showResultBlack' : 'showResultWhite', 'showEmpty'])
        }, [
          (_ctx.theme === 'dark')
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : (_openBlock(), _createElementBlock("img", _hoisted_3)),
          _hoisted_4
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.selectOption.length && _ctx.showDropdown)
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _createElementVNode("ul", {
            onKeydown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handlekeyFn($event)))
          }, [
            (_ctx.searchstr === '' && _ctx.historyOption.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("span", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearHistory && _ctx.clearHistory(...args)))
                  }, [
                    _createVNode(_component_DeleteOutlined)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOption, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.Id,
                class: _normalizeClass({ active: _ctx.activeLi === item.Id }),
                onClick: ($event: any) => (_ctx.handleChange($event, item))
              }, [
                _createElementVNode("span", null, _toDisplayString(item.Code), 1),
                _createElementVNode("span", {
                  title: item.Name
                }, _toDisplayString(item.Name), 9, _hoisted_9),
                _createElementVNode("span", null, _toDisplayString(_ctx.marketLabel(item.MarketCode)), 1)
              ], 10, _hoisted_8))
            }), 128))
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}